import React, { useEffect } from 'react';
import { updateFavicon } from '../../utlis';
import { API_URL } from '../../constants/api';
import { notification } from 'antd';
import axios from 'axios';

const KaafiPayPrivacy = () => {
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        // API call to login
        const response = await axios.get(
          `${API_URL}/api/users/get-company/user-login`
        );

        //console.log(response.data.company);
        const company = response.data.company[0];

        // Set Favicon
        if (company?.logo) {
          const iconUrl = `${API_URL}/${company.logo}`;
          updateFavicon(iconUrl); // Replace with your image URL
        }
      } catch (error) {
        // Handle error (e.g., invalid credentials)
        console.log('erro:', error);
        notification.error({
          message: `Error ${error.response?.status}: ${error.response.data.message || 'Unknown error'}`,
        });
      }
    };
    fetchCompany();
    document.title = 'Privacy Policy – Kaafi Pay';
  }, []);
  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '2rem' }}>
      <h1>Privacy Policy for Kaafi Pay</h1>
      <p>
        <strong>Effective Date:</strong> June 16, 2025
      </p>

      <h2>1. Information We Collect</h2>
      <h3>a. Business Information</h3>
      <ul>
        <li>Business name, address, and contact information.</li>
      </ul>

      <h3>b. Customer Information</h3>
      <ul>
        <li>Customer names, contact details (e.g., phone numbers, emails).</li>
        <li>
          Transaction details (e.g., invoices, receipts, payment history).
        </li>
      </ul>

      <h3>c. Usage Information</h3>
      <ul>
        <li>App usage data such as feature usage, login timestamps.</li>
        <li>
          Device and log information (IP address, operating system, etc.).
        </li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>Provide, maintain, and improve our services.</li>
        <li>Generate and manage invoices and receipts.</li>
        <li>Store and organize customer data for your business operations.</li>
        <li>Send relevant notifications or updates.</li>
        <li>Prevent fraud and enforce our terms.</li>
      </ul>

      <h2>3. Data Sharing and Disclosure</h2>
      <p>
        We <strong>do not sell</strong> your data. We may share data:
      </p>
      <ul>
        <li>
          With service providers who assist with app functionality (e.g., cloud
          storage, analytics).
        </li>
        <li>If required by law or legal process.</li>
        <li>
          To protect the rights, property, or safety of Kaafi Pay, its users, or
          the public.
        </li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We implement appropriate security measures to protect your data from
        unauthorized access, alteration, disclosure, or destruction. However, no
        system is 100% secure.
      </p>

      <h2>5. Data Retention</h2>
      <p>
        We retain your data for as long as necessary to provide our services and
        fulfill legal obligations. You can request deletion of your data by
        contacting us.
      </p>

      <h2>6. Your Rights and Choices</h2>
      <p>You have the right to:</p>
      <ul>
        <li>Access or update your information.</li>
        <li>Request deletion of your data.</li>
        <li>Object to data processing in certain cases.</li>
      </ul>
      <p>To exercise your rights, please contact us at the address below.</p>

      <h2>7. Children's Privacy</h2>
      <p>
        Kaafi Pay is not intended for use by individuals under the age of 13. We
        do not knowingly collect data from children.
      </p>

      <h2>8. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. We will notify you
        of significant changes by updating the “Effective Date” and possibly
        through in-app notifications.
      </p>

      <h2>9. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, please
        contact us:
      </p>
      <p>
        <strong>Kaafi Pay Team</strong>
        <br />
        Email: sales@kaafipay.so
        <br />
        Address: Mogadishu, Somalia
        <br />
        Phone: 252615190777
      </p>
    </div>
  );
};

export default KaafiPayPrivacy;
